import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import { FaEdit, FaTimes } from "react-icons/fa";
import Swal from "sweetalert2";
import axios from 'axios';


function Institutions({handleMenuClick}){
  //variables
    const [searchValue, setSearchValue] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setDataPerPage] = useState(10);
    const [entries, setEntries] = useState([]);
    const [updateTrigger, setUpdateTrigger] = useState(false);

    //funciones
    const filteredData = searchValue
    ? entries.filter((data) =>
        data.name.toUpperCase().includes(searchValue.toUpperCase())
      )
    : entries;

    const indexOfLastData = currentPage * dataPerPage;
    const indexOfFirstData = indexOfLastData - dataPerPage;
  
    const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);

    const totalPageCount = Math.ceil(filteredData.length / dataPerPage);
      const pageNumbers = [];
      const maxPageNumbersToShow = 20;
  
    let startPage, endPage;
    if (totalPageCount <= maxPageNumbersToShow) {
      startPage = 1;
      endPage = totalPageCount;
    } else {
      startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
      endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);
  
      if (endPage - startPage < maxPageNumbersToShow) {
        startPage = endPage - maxPageNumbersToShow + 1;
      }
    }
  
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    const handleSearch = () => {
        const input = document.getElementById("searchInput");
        setSearchValue(input.value.trim());
    };

    const showEntries = (e) => {
        setDataPerPage(e.target.value);
      };

      const getEntries = async () => {
        try {
          const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/institutions/`, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          });
          if (res.data.code === 1) {
            setEntries(res.data.data);
          } else {
            Swal.fire("Error", "Hubo un error al obtener los datos", "error");
          }
        } catch (error) {
          Swal.fire("Error", "Hubo un error al obtener los datos", "error");
        }
      }; 

      const createEntries = async () => {
        try {
          const result = await Swal.fire({
              title: "Registrar Institución",
              html:
              '<div class="form-grid">' +
              '<input type="text" id="name" class="swal2-input" placeholder="Nombre">' +
              "</div>",
              showDenyButton: true,
              confirmButtonText: "Crear",
              denyButtonText: "Cancelar",
              padding: "1px",
              color: "#000",
              backdrop: `
                  rgba(0,0,0,0.8)
              `,
              customClass: {
                  confirmButton: "btn-amc-blue",
                  denyButton: "btn-cancel",
                  title: "alert-title",
                  popup: "alert-bg",
              },
              preConfirm: function () {
                  const name = document.getElementById("name").value;
          
                  if (!name) {
                      Swal.showValidationMessage("Todos los campos son obligatorios");
                      return false;
                  }
          
                  return {
                      name
                  };
              },
          });
      
          if (result.isConfirmed) {
              const userData = result.value;
      
              const response = await axios.post(
                  `${process.env.REACT_APP_URL_BACKEND}/api/v1/institutions/store`, userData,
                  {
                      headers: {
                          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                      },
                  }
              );
      
              Swal.fire(
              "¡Creado!",
              "La institución ha sido registrado exitosamente.",
              "success"
              );
              setUpdateTrigger(!updateTrigger);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.fire("Cancelado", "Acción cancelada.", "error");
          }
      } catch (error) {
          console.error(error);
          Swal.fire("Error", "Hubo un error", "error");
      }
      };

      const updateEntries = async (id) => {
        try {
          //Obtener los datos de la institucion
          const response = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/institutions/find/${id}`,
            {
              headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
              },
          }
          );
          const entryData = response.data.data;
  
          const result = await Swal.fire({
              title: "Editar Institución",
              html:
              `<div class="form-grid">` +
              `<input type="text" id="name" class="swal2-input" placeholder="Nombre" value="${entryData[0].name}">` +
              // `<input type="text" id="code" class="swal2-input" placeholder="Código" value="${entryData[0].code}">` +
              `</div>`,
              showDenyButton: true,
              confirmButtonText: "Actualizar",
              denyButtonText: "Cancelar",
              padding: "1px",
              color: "#000",
              backdrop: `
                  rgba(0,0,0,0.8)
              `,
              customClass: {
                  confirmButton: "btn-amc-blue",
                  denyButton: "btn-cancel",
                  title: "alert-title",
                  popup: "alert-bg",
              },
              preConfirm: function () {
                  const name = document.getElementById("name").value;
                  // const code = document.getElementById("code").value;
          
                  if (!name) {
                      Swal.showValidationMessage("Todos los campos son obligatorios");
                      return false;
                  }
          
                  return {
                      name
                  };
              },
          });
  
          if (result.isConfirmed) {
              const updateUserData = result.value;
              // Realizar la solicitud POST al servidor para actualizar la institucion
              const updateResponse = await axios.post(
                  `${process.env.REACT_APP_URL_BACKEND}/api/v1/institutions/update/${id}`, updateUserData,
                  {
                      headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
                      },
                    }
              );
              console.log('Respuesta de actualización:', updateResponse);

              Swal.fire(
                  "¡Actualizado!",
                  "La institución ha sido actualizado exitosamente.",
                  "success"
              );
              setUpdateTrigger(!updateTrigger);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.fire(
                  "Cancelado",
                  "No se ha realizado ninguna actualización.",
                  "error"
              );
          }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Hubo un error", "error");
        }
      };

      const deleteEntries = async (id) => {
        try {
          const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "¡No podrás revertir esto!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminarlo",
            cancelButtonText: "No, cancelar",
            reverseButtons: true,
            buttonsStyling: true,
          });
          if (result.isConfirmed) {
            await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/institutions/destroy/${id}`, {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
              },
            });
            Swal.fire("¡Eliminado!", "La institución ha sido eliminado.", "success");
            setUpdateTrigger(!updateTrigger);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire("Cancelado");
          }
        } catch (error) {
          Swal.fire("Error", "Hubo un error", "error");
        }
      };

      const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
      };

    useEffect(() => {
      getEntries();
    }, [updateTrigger]);

    return(
        <>
      <Helmet>
        <title>Horus | Instituciones</title>
      </Helmet>
      <ScrollToTop />
      <div className="table-responsive">
        <div
          className="dataTables_wrapper dt-bootstrap4 no-footer container-fluid"
          id="datatables_wrapper"
        >
          <div className="text-right mb-4 ">
            <button
              className="btnn"
              onClick={createEntries}
            >
              Añadir Instituciones
            </button>
          </div>
          <div className="row justify-content-between mb-2">
            <div className="col-sm-12 col-md-4">
              <div className="dataTables_length mb-2" id="dataTables_length">
                  <label className="d-flex justify-content-start">
                  <span className="mr-2 p-2">Mostrar</span>
                  <select
                      name="datatables_length"
                      aria-controls="datatables_length"
                      className="custom-select custom-select-sm form-control-sm narrow-select p-2"
                      onChange={showEntries}
                  >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                  </select>
                  <span className="ml-2 p-2">registros</span>
                  </label>
              </div>
            </div>
            <div className="col-sm-12 col-md-4">
              <div className="datatables_filter" id="datatables_filter">
                  <label className="d-flex justify-content-end">
                  <input
                      type="search"
                      id="searchInput"
                      className="form-control form-control-sm"
                      placeholder="Buscar..."
                      aria-controls="datatables"
                  />
                  <button className="btnn" onClick={handleSearch}>
                      Buscar
                  </button>
                  </label>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <table
                className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                role="grid"
                aria-describedby="datatables_info"
              >
                <thead>
                  <tr role="row">
                  
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "343.25px" }}
                    >
                      Nombre
                    </th>
                    
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "343.25px" }}
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.map((entry) => (
                    <tr key={entry.id}>
                      <td>{entry.name}</td>
                      <td>
                      <FaEdit className='editButton' onClick={() => { updateEntries(entry.id) }} />
                      <FaTimes className='deleteButton' onClick={() => { deleteEntries(entry.id) }} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="row">
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Anterior
                  </button>
                </li>
                {pageNumbers.map((pageNumber) => (
                  <li className="page-item" key={pageNumber}>
                    <button
                      className="page-link"
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === pageNumbers.length}
                  >
                    Siguiente
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
    )
}

export default Institutions;